var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("pacs008.process_SCT") } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c("div", { attrs: { slot: "fixed" }, slot: "fixed" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "44px",
                    width: "100%",
                  },
                },
                [
                  _c("cm-messages-filter", {
                    staticClass: "researchfilter",
                    staticStyle: { position: "relative", "z-index": "10" },
                    attrs: {
                      propedServiceId: "10",
                      filterType: "list",
                      mode: this.mode,
                    },
                    on: {
                      applyFilter: function ($event) {
                        return _vm.applyFilter($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _c("cm-messages-filter", {
                                staticClass: "researchfilter",
                                staticStyle: {
                                  position: "relative",
                                  "z-index": "10",
                                },
                                attrs: {
                                  filterType: "list",
                                  format: "SCT",
                                  mode: this.mode,
                                  randomId: _vm.randomId,
                                  propedServiceId: "10",
                                  countResults:
                                    _vm.paginationObject.nbResultsTotal.toString(),
                                },
                                on: {
                                  applyFilter: function ($event) {
                                    return _vm.applyFilter($event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSmartphoneOS
                        ? _c("div", { style: _vm.customMobileLayoutStyle })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center" },
                      [
                        _c("b-col", { attrs: { sm: "12" } }, [
                          _c("hr", { staticClass: "w-100" }),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _c(
                          "div",
                          [
                            _vm.items.length
                              ? _c("b-table", {
                                  staticClass: "mt-3",
                                  attrs: {
                                    hover: "",
                                    responsive: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "sort-by": _vm.sortBy,
                                    "sort-desc": _vm.sortDir,
                                  },
                                  on: {
                                    "update:sortBy": function ($event) {
                                      _vm.sortBy = $event
                                    },
                                    "update:sort-by": function ($event) {
                                      _vm.sortBy = $event
                                    },
                                    "update:sortDesc": function ($event) {
                                      _vm.sortDir = $event
                                    },
                                    "update:sort-desc": function ($event) {
                                      _vm.sortDir = $event
                                    },
                                    "head-clicked": _vm.sortTable,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(protocol)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "text-center" },
                                              [
                                                data.value === "webservice"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-globe",
                                                      attrs: {
                                                        title: data.value,
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                data.value === "remote folder"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-folder-arrow-up",
                                                      attrs: {
                                                        title: data.value,
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                data.value === "interface"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-file-arrow-up",
                                                      attrs: {
                                                        title: data.value,
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(statut)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                },
                                                attrs: { title: data.value },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      data.item.statusClass,
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(msgIdd)",
                                        fn: function (data) {
                                          return [
                                            data.item.statut === "Accepté" ||
                                            data.item.statut === "Accepted"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center",
                                                    staticStyle: {
                                                      overflow: "hidden",
                                                      "text-overflow":
                                                        "ellipsis",
                                                    },
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-link-purple",
                                                        attrs: {
                                                          title: data.value,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.redirectToTransactions(
                                                              data.value
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(data.value)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center",
                                                    staticStyle: {
                                                      overflow: "hidden",
                                                      "text-overflow":
                                                        "ellipsis",
                                                    },
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-link-purple",
                                                        staticStyle: {
                                                          cursor: "default",
                                                        },
                                                        attrs: {
                                                          title: data.value,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(data.value)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell()",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: data.value,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(data.value))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    145903155
                                  ),
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("span", { staticClass: "noResult" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("common.no_result")) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                ),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "justify-content-end mt-5" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "mt-3",
                            attrs: { lg: "2", offset: "7" },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.exportList()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-solid fa-arrow-up-from-bracket",
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("pain008.extract_list")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "b-col",
                          [
                            _c("cm-pagination", {
                              attrs: {
                                maxResultsByPage:
                                  _vm.paginationObject.maxResults,
                                firstIndex: _vm.paginationObject.firstIndex,
                                nbResultsTotal:
                                  _vm.paginationObject.nbResultsTotal,
                                refreshEvent: _vm.paginationObject.refresh,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }